/*
    内容复用模板
 */
<template>
    <section class="page-content-box">
        <div class="page-content-he" ref="header">
            <slot name="header"></slot>
        </div>
        <div class="page-content-con" @scroll="contentScroll">
            <el-card class="el-card-page-box" :style="top">
                <slot name="content"></slot>
            </el-card>
        </div>
        <el-backtop target=".page-content-con"></el-backtop>
    </section>
</template>
<script>
export default {
    data(){
        return {
            top:'',
        }
    },
    watch:{
       
    },
    mounted(){
        this.$nextTick(function () {
           this.setheaderHeight()
        })
    },
    updated(){
        this.$nextTick(function () {        
            this.setheaderHeight()
        })
    },
    methods:{
        setheaderHeight(){  //重新设置高度
            this.top=`margin-top:${this.$refs.header.offsetHeight+20}px`;
        },
        contentScroll(e){
            this.$emit('contentScroll',e)
        }
    },
}
</script>
<style scoped>
    .page-content-box{
        position: relative;
        height: 100%;
    }
    .page-content-con{
        height: 100%;
        overflow: auto;
    }
    .page-content-he{
        background: #ffffff;
        padding: 15px 20px;
        width: 100%;
        box-sizing: border-box;
        box-shadow:0px 15px 10px -15px #ccc;
        position:absolute;
        top: 0;
        left: 0;
        z-index: 100;
        max-height: 120px;
    }
    .el-card-page-box{
        margin: 0 20px;
        margin-top: 91px;
        /* margin-top: 20px; */
        margin-bottom: 80px;
        /* min-height: 785px; */
        min-height: 830px;
    }
</style>
